export default __webpack_public_path__ + "static/us-consumer-reviews-customers-reviews-6123f4b7cd5b9336421801ecaf911a6f.jpeg";